import React from 'react';

export const BlockIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <path fill="none" stroke="#006FCF" strokeWidth="1.2" d="M10 1c-4.973 0-9 4.027-9 9s4.027 9 9 9 9-4.027 9-9-4.027-9-9-9zm6.136 2.864L3.864 16.954" />
  </svg>
);

export default BlockIcon;
